import { render } from "./BetRoom.vue?vue&type=template&id=010c6e72&scoped=true"
import script from "./BetRoom.vue?vue&type=script&lang=js"
export * from "./BetRoom.vue?vue&type=script&lang=js"

import "./BetRoom.vue?vue&type=style&index=0&id=010c6e72&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010c6e72"]])

export default __exports__